import { Rota } from "./rota";

export class LojistikKaydetRequest {
    id: number;
    tarih: Date;
    mazotBazFiyati: number;
    aciklama: string;
    cariId: number;
    subeId: number;

    rotalar: Rota[];
}
